<template>
  <div class="monitor">
    <!-- 图标 -->

    <!-- 图标二-->
    <el-row :gutter="30">
      <el-col :xs="24" :sm="24" :md="11" :lg="7" :xl="7">
        <!-- <el-row class="monitor-header-two" :gutter="20" style="margin-bottom: 20px;">
          <el-col :span="24">
            <div class="monitor-info-name">
              <div class="monitor-cart-name-left">Announcement</div>
               <div class="monitor-cart-name-right">More</div>
            </div>
          </el-col>
          <el-col :span="24">
            <InformationList />
          </el-col>
        </el-row> -->
       <InformationList />
       
        <el-row class="monitor-header-two" :gutter="20" style="margin-bottom: 20px;">
          <el-col :span="24">
            <div class="monitor-cart-name">
              <div class="monitor-cart-name-left">Analysis of equipment sales</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="monitor-header-users-time">
              <div
                class="monitor-subtext-name"
              >Number of equipment sold this year : {{currentYearTotal}} , Growth rate : {{saleRate}}</div>
            </div>
            <ve-bar :data="equipmentData"></ve-bar>
          </el-col>
        </el-row>
      </el-col>
      <el-col :xs="24" :sm="24" :md="13" :lg="17" :xl="17">
        <el-row class="monitor-header-two" :gutter="20">
          <el-col :span="24">
            <div class="monitor-cart-name">
              <div class="monitor-cart-name-left">Visitor Analysis</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="monitor-visitors monitor-visitors-scale">
              <div class="monitor-visitors-left">
                <ve-line height="100%" :data="visitorData"></ve-line>
              </div>
              <div class="monitor-visitors-right">
                <div class="monitor-header-users-time">
                  <div class="monitor-subtext-name">Annual statistics</div>
                </div>
                <div
                  class="monitor-visitors-right-list"
                  v-for="(item,index) in colors"
                  :key="index"
                >
                  <div
                    class="monitor-visitors-right-list-name"
                    v-if="yearVisitorData.rows.length>0"
                  >{{yearVisitorData.rows[index]['key']}}</div>
                  <div
                    class="monitor-visitors-right-list-number"
                    v-if="yearVisitorData.rows.length>0"
                  >{{yearVisitorData.rows[index]['val']}}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row class="monitor-header-two" :gutter="20">
          <el-col :span="24">
            <div class="monitor-cart-name">
              <div class="monitor-cart-name-left">Equipment distribution</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="monitor-map monitor-visitors-scale">
              <Maps />
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import InformationList from '@/components/analyze/InformationList'
import Maps from '@/components/analyze/map'
import countTo from 'vue-count-to'

export default {
  data() {
    return {
      value1: '',
      config: {
        data: [66],
        shape: 'roundRect',
      },

      visitorData: {
        columns: ['day', 'Agents', 'Plumbing Companies', 'Plumbers'],
        rows: [],
        // rows: [
        //     { 'day': '1', 'Agents': Math.random()*500, 'Plumbing Companies': Math.random()*500, 'Plumbers': Math.random()*500 },
        // ]
      },
      yearVisitorData: {
        columns: ['key', 'val'],
        rows: [],
        // rows: [
        //     { 'key': 'New Agents', 'val': 35 },
        //     { 'key': 'YoY growth rate', 'val': '80%' },
        //     { 'key': 'New Plumbing Companies', 'val': 125 },
        //     { 'key': 'YoY growth rate', 'val': '90%' },
        //     { 'key': 'New Plumbers', 'val': 256 },
        //     { 'key': 'YoY growth rate', 'val': '100%' }
        // ]
      },
      equipmentData: {
        columns: [],
        rows: [],
        // columns: ['mon', 2020, 2021],
        // rows: [
        //     { 'mon': 'Jan', 2020: Math.random()*500, 2021: Math.random()*500},
        //     { 'mon': 'Feb', 2020: Math.random()*500, 2021: Math.random()*500},
        //     { 'mon': 'Mar', 2020: Math.random()*500, 2021: Math.random()*500},
        //     { 'mon': 'Apr', 2020: Math.random()*500, 2021: Math.random()*500},
        //     { 'mon': 'May', 2020: Math.random()*500, 2021: Math.random()*500},
        //     { 'mon': 'June', 2020: Math.random()*500, 2021: Math.random()*500},
        //     { 'mon': 'july', 2020: Math.random()*500, 2021: Math.random()*500},
        //     { 'mon': 'Aug', 2020: Math.random()*500, 2021: Math.random()*500},
        //     { 'mon': 'Sept', 2020: Math.random()*500, 2021: Math.random()*500},
        //     { 'mon': 'Oct', 2020: Math.random()*500, 2021: Math.random()*500},
        //     { 'mon': 'Nov', 2020: Math.random()*500, 2021: Math.random()*500},
        //     { 'mon': 'Dec', 2020: Math.random()*500, 2021: Math.random()*500},
        // ]
      },
      currentYearTotal: null,
      saleRate: null,
      colors: [
        '#F141AF',
        '#F85E1F',
        '#9830FA',
        '#0C99FD',
        '#25D9B4',
        '#1AA2FC',
      ],
      mapData2: ['1,000', '15.68%'],
    }
  },
  components: {
    InformationList,
    Maps,
    countTo,
  },
  created() {
    this.getVisitorData()
    this.getYearVisitor()
    this.getYearSales()
  },
  methods: {
    //获取 一个月 Visitor Analysis 数据
    getVisitorData() {
      this.$get(`index/getVisitor`).then(({ data: res }) => {
        // console.log(res.data)
        this.visitorData.rows = res.data
      })
    },
    //获取 一年 Visitor Analysis 数据
    getYearVisitor() {
      this.$get(`index/getYearVisitor`).then(({ data: res }) => {
        // console.log(res.data)
        this.yearVisitorData.rows = res.data
      })
    },
    //获取Analysis of equipment sales 数据
    getYearSales() {
      this.$get(`index/getEuipSales`).then(({ data: res }) => {
        // console.log('getEuipSales', res.data)
        // console.log('columns',res.data.columns)
        // console.log('rows', res.data.rows)
        this.equipmentData.columns = res.data.columns
        this.equipmentData.rows = res.data.rows
        this.currentYearTotal = res.data.currentYearTotal
        this.saleRate = res.data.saleRate
      })
    },
  },
}
</script>

<style scoped>
.monitor {
  background: #f5f7f9;
  padding: 10px 25px;
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
}
.monitor-header {
  border: 1px solid #e6e6e6;
  background: #ffffff;
  border-radius: 5px;
  margin-bottom: 20px;
}
.monitor-header-two {
  border: 1px solid #e6e6e6;
  background: #ffffff;
  border-radius: 5px;
  margin-bottom: 20px;
}
.monitor-header-info {
  background: #ffffff;
}
.monitor-info-name {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;
}
.monitor-cart-name {
  width: 100%;
  height: 50px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;
}
.monitor-subtext-name {
  width: 100%;
  height: 20px;
  margin-top: 0px;
  display: flex;
  justify-content: space-between;
  color: #5c5c5c;
  font-size: 14px;
}
.monitor-subtext-map {
  width: 100%;
  /* height: 20px; */
  /* margin-top: -20px; */
  display: flex;
  justify-content: space-between;
  color: #5c5c5c;
  font-size: 14px;
  float: left;
}
.monitor-cart-name-left {
  width: 260px;
  height: 100%;
  /* background: blueviolet; */
  line-height: 42px;
  color: #5c5c5c;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.monitor-cart-name-left-icon {
  width: 30px;
  height: 30px;
  background: #f7eeff;
  border-radius: 2px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.monitor-cart-name-left-icon-s {
  width: 20px;
  height: 20px;
  color: blueviolet;
  fill: currentColor;
}
.monitor-cart-name-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 20px;
  cursor: pointer;
}

.monitor-cart-name-right-list {
  width: 60px;
  height: 50px;
  /* background: chartreuse; */
  text-align: center;
  line-height: 50px;
  color: #515a6e;
  font-size: 14px;
  cursor: pointer;
}
.monitor-cart-name-right-list:hover {
  color: #2d8cf0;
}
.monitor-cart-box {
  /*background: chocolate;*/
  width: 100%;
  height: 100px;
  padding: 10px 5px;
  box-sizing: border-box;
  /* border: 1px solid #E6E6E6; */
  background: #ffffff;
  border-radius: 5px;
  margin-bottom: 20px;
}
.monitor-cart-probability {
  background: cornflowerblue;
  width: 100%;
  height: 210px;
  padding: 20px 15px 0px;
  box-sizing: border-box;
}
.monitor-cart-probability-box {
  width: 100%;
  height: 80%;
  /* border: 1px solid #515A6E; */
  border-radius: 5px;
}
.monitor-cart-probability-name {
  width: 100%;
  height: 20%;
  text-align: center;
  line-height: 34px;
  /* background: chartreuse; */
  color: #515a6e;
  font-size: 14px;
  cursor: pointer;
}
.monitor-visitors {
  width: 100%;
  height: 400px;
}
.monitor-map {
  width: 100%;
  height: 500px;
}
.monitor-visitors-scale {
  display: flex;
  justify-content: space-between;
}
.monitor-visitors-left {
  width: 70%;
  height: 100%;
}
.monitor-visitors-right {
  width: 30%;
  height: 100%;
  /* background: chocolate; */
  padding: 20px;
  box-sizing: border-box;
}
.monitor-visitors-right-list {
  width: 100%;
  height: 40px;
  /* background: cyan; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.monitor-visitors-right-list-icon {
  width: 15px;
  height: 15px;
  color: #666666;
  fill: currentColor;
}
.monitor-visitors-right-list-name {
  /*width: 180px;*/
  /* background: darkgoldenrod; */
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  color: #595959;
  padding-left: 10px;
  box-sizing: border-box;
  word-wrap: break-word;
}
.monitor-visitors-right-list-number {
  flex: 1;
  /* background: yellowgreen; */
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  color: #8c8c8c;
  padding-left: 10px;
  box-sizing: border-box;
  text-align: right;
  padding-right: 15px;
  word-wrap: break-word;
}

.monitor-visitors-left-list {
  width: 100%;
  height: 40px;
  /* background: cyan; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.monitor-visitors-left-list-icon {
  width: 15px;
  height: 15px;
  color: #666666;
  fill: currentColor;
}
.monitor-visitors-left-list-name {
  width: 250px;
  /* background: darkgoldenrod; */
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  color: #595959;
  padding-left: 10px;
  box-sizing: border-box;
  word-wrap: break-word;
}
.monitor-visitors-left-list-number {
  flex: 1;
  /* background: yellowgreen; */
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  color: #8c8c8c;
  padding-left: 10px;
  box-sizing: border-box;
  text-align: right;
  padding-right: 15px;
  word-wrap: break-word;
}

.monitor-header-users {
  width: 100%;
  height: auto;
  padding: 0px 10px;
  box-sizing: border-box;
}
.monitor-header-users-time {
  width: 100%;
  height: 40px;
  line-height: 20px;
  font-size: 12px;
  color: #515a6e;
  text-align: left;
  margin-bottom: 10px;
}
.monitor-header-users-number {
  width: 100%;
  height: 58px;
  text-align: center;
  font-size: 40px;
  line-height: 58px;
  color: #515a6e;
  font-weight: bold;
}
.monitor-header-users-message {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  color: #515a6e;
  text-align: center;
}
/* 用户数 */
.monitor-header-users-icon {
  width: 100%;
  height: 50px;
  text-align: center;
  /* background: chocolate; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.monitor-header-users-icon-s {
  width: 36px;
  height: 36px;
  fill: currentColor;
  color: #2399fa;
}
/* 评论 */
.monitor-header-comment {
  width: 100%;
  height: auto;
}
.monitor-header-comment .monitor-header-comment-list:nth-last-child(1) {
  border-bottom-color: transparent;
}
.monitor-header-comment-list {
  width: 100%;
  height: 120px;
  display: flex;
  box-sizing: border-box;
  border-bottom: 1px solid #e8eaec;
}
.monitor-header-comment-list-li {
  width: 33%;
  height: 120px;
}
.monitor-header-comment-list-li-number {
  font-weight: bold;
  font-size: 30px;
  color: #515a6e;
  line-height: 120px;
  text-align: center;
}
.monitor-header-comment-list-li-icon {
  width: 50px;
  height: 50px;
  color: #fbd971;
  fill: currentColor;
}
.monitor-header-comment-list-li-tag {
  display: flex;
  /* background: cyan; */
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.monitor-header-comment-list-li-tag-text {
  width: 100%;
  height: 35px;
  text-align: center;
  line-height: 35px;
  color: #808695;
  font-size: 14px;
}
.monitor-header-comment-list-li-percentage {
  height: 100%;
  line-height: 120px;
  color: #36c17b;
  font-size: 18px;
  text-align: center;
}
</style>